/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectOwnerResponseAdminAdminDto } from '../../models/project-owner-response-admin-admin-dto';

export interface AdminProjectOwnersControllerGetProjectOwnerById$Params {
  id: string;
  includeProjects: string;
}

export function adminProjectOwnersControllerGetProjectOwnerById(http: HttpClient, rootUrl: string, params: AdminProjectOwnersControllerGetProjectOwnerById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectOwnersControllerGetProjectOwnerById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('includeProjects', params.includeProjects, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>;
    })
  );
}

adminProjectOwnersControllerGetProjectOwnerById.PATH = '/admin/project-owners/{id}';
